import { render, staticRenderFns } from "./SPTables.vue?vue&type=template&id=4bcdb158&"
import script from "./SPTables.vue?vue&type=script&lang=js&"
export * from "./SPTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports